import { render, staticRenderFns } from "./query_competing_products.vue?vue&type=template&id=f8f30fca&scoped=true"
import script from "./query_competing_products.vue?vue&type=script&lang=js"
export * from "./query_competing_products.vue?vue&type=script&lang=js"
import style0 from "./query_competing_products.vue?vue&type=style&index=0&id=f8f30fca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f30fca",
  null
  
)

export default component.exports